class BESSAppProjectVersions extends BESSAppBase {

    constructor() {
        super();

        this.versionSelect = $('.app-project-versions select');
        this.versionSelect.change(this.#onChangeVersion.bind(this));
    }

    #onChangeVersion() {
        let versionVal = this.versionSelect.val();
        if ('' + versionVal !== "0") {
            window.location.href = versionVal;
        }
    }
}